/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable-next-line react-hooks/exhaustive-deps */

import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { getFirestore, doc, getDoc, collection } from "firebase/firestore";
import { getAuth } from 'firebase/auth';
import { ENV } from '../../../config/env';
import { BreakpointLRG } from '../../../utils/breakpoints';
import { useFirebase } from '../../../hooks/useFirebase';
import styles from './_navigation.module.scss';

interface NavigationInterface {
  showNavOptions?: boolean;
  showCurrentUserDetails?: boolean;
}

const Navigation: React.FC<NavigationInterface> = ({
  showNavOptions = true,
  showCurrentUserDetails = true,
}) => {
  const [open, setOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState<string | undefined>('');
  const [firebaseDocumentData, setFirebaseDocumentData] = useState<any>(null);
  const [hideActions, setHideActions] = useState(false);

  const firebaseApp = useFirebase();
  const auth = firebaseApp ? getAuth(firebaseApp) : null;
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const page = new URLSearchParams(location.search).get('page');
    setHideActions(page === 'payment' || !showNavOptions);
  }, [location.search, showNavOptions]);

  useEffect(() => {
    if (!firebaseApp) return;
    const unsubscribe = auth?.onAuthStateChanged((user) => {
      if (user) setCurrentUser(user.displayName?.split(' ')[0]);
    });
    return unsubscribe;
  }, [firebaseApp, auth]);

  useEffect(() => {
    if (!firebaseApp) return;
    const unsubscribe = auth?.onAuthStateChanged(async (user) => {
      if (user) {
        setCurrentUser(user.displayName?.split(' ')[0]);
        const userDocRef = doc(collection(getFirestore(firebaseApp), 'Users'), user.uid);
        const firebaseDocument = await getDoc(userDocRef);
        setFirebaseDocumentData(firebaseDocument.data());
      }
    });
    return unsubscribe;
  }, [firebaseApp, auth]);

  const handleJoinTodayClick = () => {
    const url = ENV.isDevelopment
      ? 'https://www.staging17.defeatdiabetes.com.au/register'
      : 'https://www.defeatdiabetes.com.au/register';
    window.open(url, '_blank');
  };

  const handleLogout = async () => {
    await auth?.signOut();
    navigate('/login/');
  };

  const renderMenuItems = () => (
    <ul className={styles.menu}>
      {firebaseDocumentData?.firstName ? (
        <div className={styles.userMenuContainer}>
          <li className={styles.userGreeting}>{`Hi ${firebaseDocumentData.firstName},`}</li>
          <li>
            <Link to="/login" onClick={handleLogout} className={styles.menuBarItemLink}>Logout</Link>
          </li>
        </div>
      ) : (
        !showCurrentUserDetails && (
          <li>
            <Link to="/login" className={styles.menuItem}>Login</Link>
          </li>
        )
      )}
    </ul>
  );

  return (
    <nav className={styles.navHeader}>
      <BreakpointLRG>
        {(matches: boolean) =>
          matches ? (
            <>
              <Link to="/account/" className={styles.logotype}>
                <img src="/logotype.svg" alt="Logo" />
              </Link>
              {showNavOptions && renderMenuItems()}
            </>
          ) : (
            <>
              {!hideActions && (
                <button className={styles.buttonMenuOpen} onClick={() => setOpen(!open)} />
              )}
              <Link to="/" className={styles.logoMark}>
                <img src="/logomark.svg" alt="Logo" />
              </Link>
              {!currentUser && (
                <div onClick={handleJoinTodayClick} style={{ cursor: 'pointer' }}>
                  <img src="/icon-download.svg" alt="Download" />
                </div>
              )}
              {showNavOptions && renderMenuItems()}
            </>
          )
        }
      </BreakpointLRG>
    </nav>
  );
};

export default Navigation;
